module.exports = __webpack_public_path__ + "img/img_chanpingshichang.281586d7.png";